import Collection from "../../../../core/data-structures/collection";
import HourlyCostHistory from "./hourly-cost-history";


export default class HourlyCostHistoryCollection extends Collection<HourlyCostHistory> {

    constructor(models:any) {
        super(models);
    }

    static initFromJson(data: any):HourlyCostHistoryCollection {
        const models : HourlyCostHistory[] = _.map(data, (record:any)=>{
            return new HourlyCostHistory(record)
        })

        return new HourlyCostHistoryCollection(models)
    }
}